import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  buttonNoBorder: {
    backgroundColor: 'transparent',
    border: 'none'
  },
  listItem: {
    height: 30,
  },
  iconItem: {
    width: 35,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  }
}));
